import React from "react";
import { Link, NavLink } from "react-router-dom";

const EmpSidebar = () => {
  return (
    <div>
      <aside className="navbar-aside" id="offcanvas_aside">
        <div className="aside-top">
          <Link to="/emp" className="brand-wrap">
            <img
              src="/images/logo.png"
              style={{ width: 1000, height: 90 }}
              className="logo"
              alt="HR 360 Icon"
            />
          </Link>
          <div>
            <button className="btn btn-icon btn-aside-minimize">
              <i className="text-muted fas fa-stream"></i>
            </button>
          </div>
        </div>

        <nav>
          <ul className="menu-aside">
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/emp"
                exact={true}
              >
                <i className="icon fas fa-home"></i>
                <span className="text">Dashboard</span>
              </NavLink>
            </li>

            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link"
                to="/Tckt"
              >
                <i className="icon fas fa-ticket-alt"></i>
                <span className="text">Tickets</span>
              </NavLink>
            </li>

            <li className="menu-item">
              { <NavLink
                activeClassName="active"
                className="menu-link"
                to="/empattendance"
              >
                <i className="icon fas fa-sharp fa-solid fa-clipboard-check"></i>
                <span className="text">Attendance</span>
              </NavLink> }
            </li>

            <li className="menu-item">
              { <NavLink
                activeClassName="active"
                className="menu-link"
                to="/EmpFeedback"
              >
               <i className="icon fas fa-solid fa-comment-lines"></i>
                <span className="text">Feedback</span>
              </NavLink> }
            </li>

            <li className="menu-item">
              { <NavLink
                activeClassName="active"
                className="menu-link"
                to="/Empcalendar"
              >
                <i className="icon fas fa-calendar"></i>
                <span className="text">Team Calendar</span>
              </NavLink> }
            </li>
            
          </ul>
          <br />
          <br />
        </nav>
      </aside>
    </div>
  );
};

export default EmpSidebar;
